import {
    createApiService
} from "~/services/api";

export default defineNuxtPlugin({
    name: 'services',
    setup() {
        return {
            provide: {
                apiService: createApiService(),
            }
        }
    }
})